<template>
  <div class="form-content">
    <a-form-model
      :ref="formFef"
      :rules="rules"
      :model="form"
      class="form-item">
      <a-table
        :columns="tableColumns"
        :data-source="fieldList"
        row-key="prop"
        class="form-table"
        size="small"
        :pagination="false"
      >
        <span slot="oldName" slot-scope="text, record">
          <span v-if="rules[record.prop]" class="requireStyle">*</span>
          {{record.label}}
        </span>
        <template slot="newName" slot-scope="text, record">
          <a-form-model-item
            :rules="rules[record.prop]"
            :prop="record.prop"
          >
            <a-select
              v-model="form[record.prop]"
              show-search
              style="width: 100%; max-width: 300px"
              placeholder="请选择"
              allow-clear
              @change="changeInfo"
            >
              <a-select-option
                v-for="(item, index) in correspondingList"
                :key="index"
                :value="item"
              >
                {{item}}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </template>
        <template slot="defalueValue" slot-scope="text, record, index">
          <a-form-model-item
            :rules="rules[record.default]"
            :prop="record.default"
          >
            <a-date-picker
              v-if="fieldList[index].type === 'time'"
              v-model="form[record.default]"
              show-time
              placeholder="请选择"
              style="width: 100%"
            />
            <a-input-number
              v-else-if="fieldList[index].type === 'number'"
              v-model="form[record.default]"
              style="width: 100%"
              placeholder="请输入"
            />
            <a-select
              v-else-if="fieldList[index].list"
              v-model="form[record.default]"
              style="width: 100%"
              :allow-clear="record.canDelete"
            >
              <a-select-option
                v-for="opt in fieldList[index].list"
                :key="opt.value"
                :value="opt.value"
              >
                {{opt.label}}
              </a-select-option>
            </a-select>
            <a-input
              v-else
              v-model="form[record.default]"
              :max-length="fieldList[index].maxLength"
              placeholder="请输入"
              @change="changeInfo"
            />
          </a-form-model-item>
        </template>
      </a-table>
    </a-form-model>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  name: 'FormItem',
  props: {
    formFef: {
      type: String,
      default: ''
    },
    form: {
      type: Object,
      default: () => {},
    },
    fieldList: {
      type: Array,
      default: () => []
    },
    rules: {
      type: Object,
      default: () => {},
    },
    correspondingList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      tableColumns: [
        {
          title: '原始模板表头名称',
          dataIndex: 'oldName',
          key: 'oldName',
          scopedSlots: { customRender: 'oldName' },
        },
        {
          title: '映射模板表头字段名称',
          dataIndex: 'newName',
          key: 'newName',
          scopedSlots: { customRender: 'newName' },
        },
        {
          title: '默认值',
          dataIndex: 'defalueValue',
          key: 'defalueValue',
          scopedSlots: { customRender: 'defalueValue' },
        },
      ]
    }
  },
  methods: {
    moment,
    changeInfo() {
      this.$refs[this.formFef].validate(async valid => {
        this.$emit('change', valid)
      })
    },
    resetValidate() {
      this.$refs[this.formFef].clearValidate()
    }
  }
}
</script>
<style lang="less" scoped>
.form-item {
  border-radius: 4px;
  background: #F4F5F6;
  padding: 20px;
  .form-table {
    background: #fff;
    /deep/ .ant-table-content {
      .ant-table-body {
        margin: 0;
        .ant-form-item {
          margin: 0;
        }
      }
      .ant-table-tbody {
        tr td {
          padding: 8px 24px;
        }
      }
      .ant-table-thead {
        background:#F2FBF8;
        height: 40px;
        tr th {
          padding: 8px 24px;
        }
      }
    }
  }
  .requireStyle {
    display: inline-block;
    margin-right: 4px;
    color: #f5222d;
    font-size: 14px;
    font-family: SimSun, sans-serif;
    line-height: 1;
  }
}
</style>